import React from 'react';
import './Carousel.scss';
import arrow from '../../../assets/intro/arrow.svg';

function Arrows({ handleClickSuits, arrowsRef }) {
  return (
    <div className="arrows" ref={arrowsRef}>
      <img
        src={arrow}
        alt="left arrow"
        className="arrows__arrow arrows__arrow--left"
        onClick={() => {
          handleClickSuits('left');
        }}
      />
      <img
        src={arrow}
        alt="right arrow"
        className="arrows__arrow arrows__arrow--right"
        onClick={() => {
          handleClickSuits('right');
        }}
      />
    </div>
  );
}

export default Arrows;
